import styled from 'styled-components/macro'
import { typography } from 'styles/typography'

export const StyledSection = styled.section`
  margin-block: var(--spacing-lg);
  scroll-margin-block: var(--spacing-lg);
  //text-align: justify;
  text-align: left;
  hyphens: auto;
`

export const Heading = styled.h2`
  ${typography.h2}
  margin: 0 0 var(--spacing-sm);
  text-align: left;
  //text-wrap: balance;
  hyphens: none;
`
